<template>
  <div id="list-body">
    <vue-headful
      :title="`영양제웨건 - ${title.replace(/<b>/gi, '').replace(/<\/b>/gi, '')}`"
    />
    <b-row>
      <b-col sm="2" id="filter-div">
        <filter-component type='search' />
      </b-col>
      <b-col sm="10" id="data-div">
        <b-row>
          <b-col sm="12">
            <item-table type='search' :loading="loading" :title="title" />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import util from '../util'
import VueHeadful from 'vue-headful'
import ItemTable from './ItemTable'
import FilterComponent from './Filter'
import {
    BRow, BCol, BTable, BBadge, BFormGroup, BFormRadioGroup, BFormRadio, BFormCheckboxGroup, BSpinner, BCollapse, BModal,
    BIconChevronDown, BIconQuestion, BIconX, BIconFilter
} from 'bootstrap-vue'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'SearchComponent',
  components: {
    BRow, BCol, BTable, BBadge, BFormGroup, BFormRadioGroup, BFormRadio, BFormCheckboxGroup, BSpinner, BCollapse, BModal,
    BIconChevronDown, BIconQuestion, BIconX, BIconFilter, VueHeadful, ItemTable, FilterComponent
  },
  props: {
    _query: { type: String }
  },
  data () {
    return {
      fullLoaded: false,
      filterOpen: false
    }
  },
  computed: {
    ...mapState({
      loading: state => state.item.loading,
      fullLoading: state => state.item.fullLoading,
      search: state => state.filter.search
    }),
    ...mapGetters('filter', {
      category: 'category',
      nutri: 'nutri'
    }),
    ...mapGetters('item', {
      item_count: 'count'
    }),
    nutri_name () {
      if (this.nutri) return this.nutri.name
    },
    isMobile () {
      return this.$store.state.isMobile
    },
    title () {
      if (this.search) {
        if (this.nutri_name)
          return `<b>${this.search}</b> 검색결과 (${this.item_count}) - 100원당 <b>${this.nutri_name}</b> 함유량 순위`
        else
          return `<b>${this.search}</b> 검색결과 (${this.item_count})`
      }
      else {
        return ''
      }
      
    }
  },
  created () {
  },
  methods: {
    loadFull() {
      this.$store.dispatch('item/fetchList', {type: 'search', full: true}).then(list => {
        this.$store.commit('item/setList', list)
        this.fullLoaded = true
      })
    }
  },
  watch: {
    '$route': {
      immediate: true,
      handler(v) {
        let params = v.params
        let query = v.query
        this.$store.dispatch('filter/updateFromRoute', {type: 'search', params, query}).then(() => {
          this.$store.dispatch('item/fetchList', {full: false}).then(list => {
            this.$store.commit('item/setList', list)
          }).catch(err => {
            console.log(err)
          })
        })
      }
    }
  }
}
</script>
<style>
@media only screen and (max-width: 600px) {
  .empty-text {
    text-align: left !important;
  }
  .spinner-wrapper {
    text-align: left !important;
  }

  #data-div {
    border-left: none !important;
  }
}
.text-center {
  text-align: left !important;
}

</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.bold {
  font-weight: bold;;
}
.float-right {
  float: right;
}
.text-right {
  text-align: right;
}

.button-load {
  margin-bottom: 50px;
}

#filter-div {
  padding: 20px;
  overflow: auto;
}

#list-body {
  width: 100%;
  padding: 0 15px;
}

#data-div {
  border-left: 1px solid #d9d9d9;
  padding: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Search.vue